import React, { ReactNode } from 'react';
import styled from 'styled-components';
import InsightsChatDock from 'components/InsightsChat/InsightsChatDock';
import {
  FADE_IN_ELEMENT_ID,
  SLIDE_OUT_ELEMENT_ID,
} from '../../../../constants';
import MaintenanceBanner from '../../../../components/MaintenanceBanner';
import TodayOverrideOverlay from './TodayOverrideOverlay';
import ViewingAppAsOverlay from './ViewingAppAsOverlay';

const OuterDiv = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const BodyDiv = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: row;
`;

const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow: hidden;
`;

const OverlaysDiv = styled.div`
  position: absolute;
  bottom: 33px;
  left: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AppLayout = ({
  TopBar,
  SideBar,
  Content,
}: {
  TopBar: ReactNode;
  SideBar: ReactNode;
  Content: ReactNode;
}) => {
  return (
    <>
      <OuterDiv>
        {TopBar}
        <MaintenanceBanner />
        <BodyDiv>
          {SideBar}
          <ContentDiv>{Content}</ContentDiv>
          <InsightsChatDock />
          <OverlaysDiv>
            <TodayOverrideOverlay />
            <ViewingAppAsOverlay />
          </OverlaysDiv>
        </BodyDiv>
      </OuterDiv>
      <div id={SLIDE_OUT_ELEMENT_ID} />
      <div id={FADE_IN_ELEMENT_ID} />
    </>
  );
};

export default AppLayout;
